
import React from "react";
import { Layout, Typography, Anchor, Divider, Button } from "antd";
import { ArrowLeftOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import BgImg from '../../assets/TermsBgImg.png';

const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const sections = [
  {
    id: "acceptance",
    title: "1. Welcome & Acceptance of Terms",
    body: `By accessing VEdanova's clinic, website, or mobile application, you agree to be bound by these Terms & Conditions. VEdanova is an Ayurvedic wellness clinic focused on women's health, fertility, and holistic wellbeing. If you do not agree with any part of these terms, please discontinue use of our services.`,
  },
  {
    id: "services",
    title: "2. About Our Services",
    body: `We offer Ayurvedic consultations, Panchakarma therapies, fertility support programs, prenatal and postnatal care, and personalised wellness plans rooted in traditional Ayurvedic principles. These services are complementary in nature and are designed to work alongside, not replace, conventional medical care.`,
  },
  {
    id: "appointments",
    title: "3. Bookings, Appointments & Cancellations",
    body: `Appointments can be booked online, by phone, or in person. We request at least 24 hours' notice for cancellations or rescheduling. Repeated no-shows may result in a requirement to prepay for future bookings. Session timings may shift slightly to accommodate individual consultation needs.`,
  },
  {
    id: "eligibility",
    title: "4. Eligibility & Your Responsibilities",
    body: `Our services are intended for individuals aged 18 and above, or minors accompanied by a parent/guardian. You agree to share accurate medical and health history, including any fertility or pregnancy-related conditions, so that our practitioners can design safe and effective treatment plans. Fertility and wellness programs require your informed, written consent prior to commencement.`,
  },
  {
    id: "disclaimer",
    title: "5. Medical & Health Disclaimer",
    body: `Ayurvedic treatment outcomes vary from person to person and are not guaranteed. Our services do not replace emergency medical care — in case of a medical emergency, please contact your physician or nearest hospital immediately. Always inform us of any ongoing allopathic treatment, medication, or pregnancy so our recommendations remain safe for you.`,
  },
  {
    id: "payments",
    title: "6. Payments, Fees & Refunds",
    body: `Treatment packages must be paid in advance and are non-transferable to another individual. Refunds are considered only where a session is cancelled or rescheduled by VEdanova. Partially used packages are refunded on a pro-rata basis at the clinic's discretion.`,
  },
  {
    id: "confidentiality",
    title: "7. Confidentiality of Medical Records",
    body: `All consultation notes, medical history, and fertility or wellness records are treated as strictly confidential and are accessible only to your treating practitioners, in line with our Privacy Policy.`,
  },
  {
    id: "platform-use",
    title: "8. Use of Our Website & App",
    body: `You agree not to misuse our digital platforms, attempt unauthorised access, or interfere with their normal functioning. Any account you create is for your personal use only and must be kept secure.`,
  },
  // {
  //   id: "ip",
  //   title: "9. Intellectual Property",
  //   body: `The VEdanova name, logo, treatment protocols, and all website content are the intellectual property of VEdanova and may not be reproduced or used commercially without our written consent.`,
  // },
  // {
  //   id: "liability",
  //   title: "10. Limitation of Liability",
  //   body: `VEdanova and its practitioners shall not be held liable for outcomes arising from incomplete disclosure of medical history, discontinuation of treatment without medical advice, or circumstances beyond our reasonable control.`,
  // },
  // {
  //   id: "law",
  //   title: "11. Governing Law & Disputes",
  //   body: `These Terms are governed by the laws of India. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra.`,
  // },
  // {
  //   id: "changes",
  //   title: "12. Changes to These Terms",
  //   body: `We may update these Terms periodically to reflect changes in our services or applicable law. Continued use of our services after such updates constitutes your acceptance of the revised Terms.`,
  // },
  {
    id: "contact",
    title: "13. Contact Us",
    body: `For questions about these Terms, please reach out to our patient care team using the details below.`,
  },
];

export default function Terms() {
  return (
    <Layout className="min-h-screen bg-[#faf6ee] relative overflow-hidden">

      <Content 
      style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right center",
          backgroundSize: "700px auto",
        }}
      className="relative z-10 px-6 sm:px-10 md:px-16 py-10 sm:py-14">
        <div className="max-w-4xl mx-auto">
          <div className="flex w-full justify-center item-center text-center flex-col">
          <p className="uppercase md:text-xl text-base font-extrabold text-brand-gold">
            Legal
          </p>
          <h1
            level={1}
            className="text-4xl lg:text-5xl font-bold text-brand-forest"
          >
            Terms & Conditions
          </h1>
          <p className="font-['Inter'] text-gray-500 mt-4 mb-8">
            Please read these terms carefully before using VEdanova&rsquo;s clinic
            services, website, or mobile application.
          </p>

          <Divider className="!border-brand-lightgold" />
          </div>

          <div className="flex flex-col md:flex-row gap-10 md:gap-16">
        

            {/* Sections */}
            <div className="flex-1 min-w-0">
              {sections.map((section, idx) => (
                <section key={section.id} id={section.id} className="scroll-mt-12">
                   <h1
                    className="!font-['Cormorant_Garamond'] font-semibold !text-brand-forest md:!text-2xl text-xl !mb-3"
                  >
                    {section.title}
                  </h1>
                  <Paragraph className="font-['Inter'] text-[15px] text-gray-900">
                    {section.body}
                  </Paragraph>
                  {idx < sections.length - 1 && (
                    <Divider className="!border-brand-lightgold !my-6" />
                  )}
                </section>
              ))}

              <div className="mt-2 rounded-2xl bg-brand-emerald border border-brand-lightgold p-6 sm:p-8">
                <Title level={4} className="!font-['Cormorant_Garamond'] !text-brand-forest !mb-3">
                  Patient Care Team
                </Title>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-10 font-['Inter'] text-sm text-brand-forest/80">
                  <span className="flex items-center gap-2">
                    <MailOutlined className="text-brand-gold" /> care@vedanova.com
                  </span>
                  <span className="flex items-center gap-2">
                    <PhoneOutlined className="text-brand-gold" /> +91 98765 43210
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
}